import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ICONS from "../config/icon";
import { MonoButton } from "../kits";
import { Link } from "react-router-dom";

export default function AddCourseForm({ onCourseAdded }) {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: "",
    slug: "",
    instructor: "",
    lectures: "",
    price: "",
    priceOnline: "",
    description: [""],
    descriptionExtension: "",
    icon: "",
    category: "",
    isFavorite: false,
    videoUrl: "",
    startDate: "",
    durationDays: "",
    courseProgram: [],
  });

  const slugify = (title = "") =>
    title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

  const isValidYouTubeUrl = (url) => {
    try {
      const parsed = new URL(url);
      return parsed.hostname.includes("youtube") && parsed.searchParams.has("v");
    } catch {
      return false;
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
      slug: name === "title" ? slugify(value) : prev.slug,
    }));
  };

  const handleArrayChange = (e, field) => {
    const array = e.target.value.split("\n").filter(Boolean);
    setFormData((prev) => ({ ...prev, [field]: array }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

  const payload = {
  ...formData,
  courseProgram: formData.courseProgram, // wird in PHP zu JSON umgewandelt
};

    try {
      const res = await fetch("https://www.denisbitter.de/stage01/api/save_course.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Fehler beim Speichern.");

      alert("✅ Kurs erfolgreich gespeichert!");
      onCourseAdded?.();
      navigate("/admindashboard");
    } catch (err) {
      console.error(err);
      alert("❌ Fehler beim Speichern: " + err.message);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-3xl mx-auto bg-white p-6 rounded shadow space-y-6">
      <h2 className="text-xl font-bold">➕ Neuer Kurs</h2>

      <div className="grid grid-cols-2 gap-4">
        {["title", "slug", "instructor", "lectures", "price", "priceOnline", "category"].map((field) => (
          <div key={field}>
            <label className="text-sm font-medium capitalize">{field}</label>
            <input
              type="text"
              name={field}
              value={formData[field] || ""}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded"
              required={["title", "instructor", "price"].includes(field)}
            />
          </div>
        ))}

        <div>
          <label className="text-sm font-medium">Startdatum</label>
          <input
            type="date"
            name="startDate"
            value={formData.startDate}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="text-sm font-medium">Dauer (Tage)</label>
          <input
            type="number"
            name="durationDays"
            value={formData.durationDays}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="text-sm font-medium">Icon</label>
          <select
            name="icon"
            value={formData.icon}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          >
            <option value="">– Icon wählen –</option>
            {Object.keys(ICONS).map((key) => (
              <option key={key} value={key}>
                {key}
              </option>
            ))}
          </select>
        </div>

        <div className="flex items-center gap-2">
          <input type="checkbox" name="isFavorite" checked={formData.isFavorite} onChange={handleChange} />
          <label className="text-sm font-medium">Favorit?</label>
        </div>
      </div>

      <div>
        <label className="text-sm font-medium">Beschreibung (mehrzeilig)</label>
        <textarea
          name="description"
          value={formData.description.join("\n")}
          onChange={(e) => handleArrayChange(e, "description")}
          className="w-full border px-3 py-2 rounded"
        />
      </div>

      <div>
        <label className="text-sm font-medium">Erweiterte Beschreibung</label>
        <textarea
          name="descriptionExtension"
          value={formData.descriptionExtension}
          onChange={handleChange}
          className="w-full border px-3 py-2 rounded"
        />
      </div>

      {/* ✅ YouTube Video Input mit Validierung & Vorschau */}
      <div className="col-span-2">
        <label className="text-sm font-medium" htmlFor="videoUrl">Video URL (YouTube)</label>
        <input
          id="videoUrl"
          name="videoUrl"
          type="url"
          value={formData.videoUrl}
          onChange={handleChange}
          className="w-full border px-3 py-2 rounded"
        />
        {formData.videoUrl && !isValidYouTubeUrl(formData.videoUrl) && (
          <p className="text-red-500 text-xs mt-1">❌ Keine gültige YouTube-URL</p>
        )}

        {isValidYouTubeUrl(formData.videoUrl) && (
          <div className="mt-4 border rounded overflow-hidden aspect-video">
            <iframe
              src={formData.videoUrl.replace("watch?v=", "embed/")}
              title="YouTube Vorschau"
              className="w-full h-full"
              allowFullScreen
            ></iframe>
          </div>
        )}
      </div>

      {/* Kursprogramm */}
      <div className="space-y-2">
        <label className="text-sm font-bold">📅 Kursprogramm</label>
        {formData.courseProgram.map((day, dayIndex) => (
          <div key={dayIndex} className="p-4 border rounded bg-gray-50 space-y-2">
            <input
              type="text"
              value={day.day}
              onChange={(e) => {
                const updated = [...formData.courseProgram];
                updated[dayIndex].day = e.target.value;
                setFormData({ ...formData, courseProgram: updated });
              }}
              placeholder="z. B. 'Tag 1'"
              className="w-full border px-2 py-1 rounded"
            />
            {day.schedule.map((entry, i) => (
              <div key={i} className="grid grid-cols-3 gap-2">
                {["time", "topic", "details"].map((key) => (
                  <input
                    key={key}
                    type="text"
                    value={entry[key]}
                    placeholder={key}
                    onChange={(e) => {
                      const updated = [...formData.courseProgram];
                      updated[dayIndex].schedule[i][key] = e.target.value;
                      setFormData({ ...formData, courseProgram: updated });
                    }}
                    className="border px-2 py-1 rounded"
                  />
                ))}
              </div>
            ))}
            <button
              type="button"
              onClick={() => {
                const updated = [...formData.courseProgram];
                updated[dayIndex].schedule.push({ time: "", topic: "", details: "" });
                setFormData({ ...formData, courseProgram: updated });
              }}
              className="text-sm text-blue-600"
            >
              + Eintrag
            </button>
          </div>
        ))}

        <button
          type="button"
          onClick={() => {
            const newDay = { day: `Tag ${formData.courseProgram.length + 1}`, schedule: [] };
            setFormData({ ...formData, courseProgram: [...formData.courseProgram, newDay] });
          }}
          className="text-sm text-green-600"
        >
          + Tag hinzufügen
        </button>
      </div>

      <MonoButton type="submit" className="w-full mt-4 text-xs">
        Kurs speichern
      </MonoButton>
      <Link to="/admindashboard">
        <MonoButton className="text-xs w-full">Abbrechen</MonoButton>
      </Link>
    </form>
  );
}
